<template>
    <v-dialog v-model="dialog">
        <v-card>
            <v-card-title class="title primary white--text">
                {{'Change Backend URL'|translate}}
            </v-card-title>
            <v-card-text>
                <v-text-field v-model="targetURL" :label="'Target URL'|translate">
                </v-text-field>
            </v-card-text>
            <v-card-actions>
                <span v-if="running">{{'Setting URL.  Please wait.'|translate}}</span>
                <v-btn block class="primary" @click="updateURL" :disabled="running">{{'Set'|translate}}</v-btn>
                <v-btn block @click="dialog=false">{{'Cancel'|translate}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'setURL',
    props: {
      value: {type: Boolean, default: false}
    },
    watch: {
      value () {
        this.dialog = this.value
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
        targetURL: this.$store.state.urlStore.url,
        dialog: false,
        running: false
      }
    },
    methods: {
      async updateURL () {
        this.running = true
        await this.$store.dispatch('setURL', this.targetURL)
        await this.$store.dispatch('refreshFacilityList')
        await this.$store.dispatch('refreshPointsList')
        this.running = false
        this.dialog=false
      }
    }
  }
</script>

<style scoped>

</style>
